export const SALES_FLOW_CAMPAIGN: string = 'Sales_Lead_Flow'
